module.exports = __webpack_public_path__ + "static/media/mantra2.fd441c22.mp3";